import { Chip, Select, styled } from '@mui/material';

export const StyledFormSelect = styled(Select)`
  & .Mui-disabled {
    background-color: #efefef;
  }
`;

export const ChipStyled = styled(Chip)(() => ({
  height: '18px',
  backgroundColor: 'rgba(20, 93, 160, 0.2)',
  color: '#145DA0',
  fontWeight: 600,
  fontSize: '12px',
  fontFamily: 'Open Sans',
}));